import React, { useEffect, useState, useRef } from 'react'
import { srBookingAllowedCall } from '../../sources/book-appointments';
import Stepper from './stepper'
import BookAppointmentList from './first-page'
import CenterDetails from './center-details'
import ErrorComponent from '../Error-Component'
import BookErrorIcon from '../../images/Error_IMG.svg'
import useTranslation from '../../hooks/use-translation'
import { useLocation, useHistory } from 'react-router-dom'
import lodash from 'lodash'
import { parseQueryString } from '../../utils/utils'
import Calender from './calender'
import { useIsDesktop, useIsTablet } from '../../hooks/breakpoints'
import { useAppState } from '../../contexts/appState'
import Loader from '../Loader'
import BookingDetails from './userDetails'
import RegisterCowin from '../BookAppointments/RegisterCowin'
import config from '../../config.json';

export default ({ flow }) => {
  const [bookingAllowed, setBookingAllowed] = useState('')
  const [showPrepaidError, setShowPrepaidError] = useState(false)
  const [isStepVisible, setStepVisible] = useState(true)
  const { t } = useTranslation()
  const history = useHistory()
  const [{ centerDetails }] = useAppState()
  const query = useQuery()
  const [activeStep, setActiveStep] = useState(0)
  const isDesktop = useIsDesktop()
  const isTablet = useIsTablet()
  const [rescheduleFlow, setRescheduleFlow] = useState(false)
  const [loading, setLoading] = useState(true)
  const params = parseQueryString();
  const [cowinReg, setCowinReg] = useState(false)
  const prepaidErrorObject = useRef();

  function useQuery() {
    return new URLSearchParams(useLocation().search)
  }

  const isBookingAllowed = async (rescheduleFlow) => {
    const source_id = lodash.get(params, "source_id", '');
    const auth_token = lodash.get(params, "auth_token", '');
    const source_user_id = lodash.get(params, "source_user_id", '');
    const source_relation = lodash.get(params, "source_relation", '');
    const source_user_relation_id = lodash.get(params, "source_user_relation_id", '');
    if (!source_id || !auth_token || !source_user_id || !source_relation || !source_user_relation_id) {
      history.push('/');
    } else {
      try {
        const result = await srBookingAllowedCall()

        if (result.apiResponse === "failed" && result.statusCode === 402 && !rescheduleFlow) {
          setShowPrepaidError(true)
          prepaidErrorObject.current = {
            "message": lodash.get(result, "data.contents.error_message", t('PREPAID_VACCINE_ERROR_TEXT')),
            "external_link": lodash.get(result, "data.contents.external_link", config.jhh_webapp_url)
          };
          setLoading(false)
          return;
        }

        const { contents = {} } = result
        const { is_cowin_reg_done = true } = contents
        setCowinReg(is_cowin_reg_done)
        setBookingAllowed(result)
        setLoading(false)
      } catch (e) {
        setLoading(false)
        console.log('e', e)
        setBookingAllowed(bookingAllowed.status = 'error')
      }
    }
  }

  useEffect(() => {
    const rescheduleFlow = query.get('reschedule')
    if (rescheduleFlow) {
      setRescheduleFlow(true)
      setActiveStep(2)
    }
    isBookingAllowed(rescheduleFlow)
  }, [])

  const handleNext = () => {
    let newStep = activeStep + 1
    if (newStep > 0) {
      setActiveStep(newStep)
    }
  }

  const handleBack = (isChange = true) => {
    if (rescheduleFlow && isChange) {
      query.delete('reschedule')
      history.push(`/my-appointment/scheduled?${query.toString()}`)
    } else {
      let newStep = activeStep - 1
      if (newStep >= 0) {
        setActiveStep(newStep)
      }
    }
  }

  const onTryAgainClick = () => {
    setStepVisible(true)
    setActiveStep(0)
  }

  const setcowinRegistration = () => {
    setCowinReg(true)
  }

  const Steps = [t('SELECT_CENTERS'), t('CENTER_DETAILS'), t('SELECT_DATE'), t('DETAILS')]

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <BookAppointmentList handleNext={handleNext} flow={flow} />
      case 1:
        return <CenterDetails handleNext={handleNext} data={centerDetails} />
      case 2:
        return <Calender handleNext={handleNext} t={t} />
      case 3:
        return <BookingDetails handleNext={handleNext} handleBack={handleBack} tryAgainClick={onTryAgainClick} showSteps={(e) => setStepVisible(e)
        } />
      default:
        return ''
    }
  }

  const onPrepaidButtonClick = (redirectUrl) => {
    window.open(redirectUrl, '_blank');
  }

  const renderDesktop = () => (
    <div style={{ background: '#ffffff', paddingTop: '1rem', width: '100%', paddingLeft: '3.875rem', paddingRight: '0rem' }}>
      {(bookingAllowed.status === 'success' || rescheduleFlow) ? (cowinReg ? <>{isStepVisible && <Stepper steps={Steps} currentStep={activeStep} handleBack={handleBack} />}
        {getStepContent(activeStep)} </> : <RegisterCowin setcowinRegistration={setcowinRegistration} />)
        :
        (
          showPrepaidError ?
            <ErrorComponent
              image={BookErrorIcon}
              text={prepaidErrorObject.current.message}
              textCss='no-appointments-text'
              subTextCss='no-appointments-sub-text'
              showButton={true}
              buttonText={t('PROCEED')}
              buttonClickCallback={() => onPrepaidButtonClick(prepaidErrorObject.current.external_link)}
            />
            :
            <ErrorComponent
              image={BookErrorIcon}
              text={t('BOOK_ERROR_TEXT')}
              textCss='no-appointments-text'
              subTextCss='no-appointments-sub-text'
            />
        )
      }
    </div>
  )

  const renderMobile = () => (
    <div style={{ background: '#ffffff', padding: '1rem 0.625rem 0rem 0.625rem', width: '100vw' }}>
      {(bookingAllowed.status === 'success' || rescheduleFlow) ? (cowinReg ? <> {isStepVisible && <Stepper steps={Steps} currentStep={activeStep} handleBack={handleBack} />}
        {getStepContent(activeStep)} </> : <RegisterCowin setcowinRegistration={setcowinRegistration} />)
        :
        (
          showPrepaidError ?
            <ErrorComponent
              image={BookErrorIcon}
              text={prepaidErrorObject.current.message}
              textCss='no-appointments-text'
              subTextCss='no-appointments-sub-text'
              showButton={true}
              buttonText={t('PROCEED')}
              buttonClickCallback={() => onPrepaidButtonClick(prepaidErrorObject.current.external_link)}
            />
            :
            <ErrorComponent
              image={BookErrorIcon}
              text={t('BOOK_ERROR_TEXT')}
              textCss='no-appointments-text'
              subTextCss='no-appointments-sub-text'
            />
        )
      }
    </div>
  )
  return (
    <>{loading ? <Loader loadingCount={1} /> : (isDesktop || isTablet) ? renderDesktop() : renderMobile()}</>
  )
}
